let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7ZpqL"), load("f1WN5"), load("joJy8"), load("aHE9G"), load("ffEVr"), load("bAbyV")]).then(() => parcelRequire('bHS4c'));